var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFax(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#4946FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 28.5C26 27.67 26.67 27 27.5 27C28.33 27 29 27.67 29 28.5C29 29.33 28.33 30 27.5 30C26.67 30 26 29.33 26 28.5ZM27.5 32C26.67 32 26 32.67 26 33.5C26 34.33 26.67 35 27.5 35C28.33 35 29 34.33 29 33.5C29 32.67 28.33 32 27.5 32ZM32.5 30C33.33 30 34 29.33 34 28.5C34 27.67 33.33 27 32.5 27C31.67 27 31 27.67 31 28.5C31 29.33 31.67 30 32.5 30ZM32.5 35C33.33 35 34 34.33 34 33.5C34 32.67 33.33 32 32.5 32C31.67 32 31 32.67 31 33.5C31 34.33 31.67 35 32.5 35ZM39 21.24V34C39 36.76 36.76 39 34 39H19C16.79 39 15 37.21 15 35V23C15 20.79 16.79 19 19 19C21.21 19 23 20.79 23 23H25V19C25 16.79 26.79 15 29 15H32.76C33.83 15 34.83 15.42 35.59 16.17L37.83 18.41C38.57 19.15 39 20.18 39 21.24ZM21 23C21 21.9 20.1 21 19 21C17.9 21 17 21.9 17 23V35C17 36.1 17.9 37 19 37C20.1 37 21 36.1 21 35V23ZM27 23H37V21.24C37 21.16 37 21.08 36.98 21H35C33.9 21 33 20.1 33 19V17.02C32.92 17.02 32.84 17 32.76 17H29C27.9 17 27 17.9 27 19V23ZM37 25H23V35C23 35.73 22.8 36.41 22.46 37H34C35.65 37 37 35.65 37 34V25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFax);
export default __webpack_public_path__ + "static/media/fax.e3cf9ba5130c17553e26a38b07c7c437.svg";
export { ForwardRef as ReactComponent };